export const downloadResourceType = 'download';
